import {useState, useEffect, useRef} from "react";
import styles from "./index.module.scss";
import Cv from "../global/cvButton/Cv";
import Illustration3DScene from "./Illustration3DScene";
import { motion } from "framer-motion";

const AsideIllustration = ({ src }) => {
  const firstLoad = useRef(true);

  const [flex, setFlex] = useState("0 0 35%");
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    firstLoad.current = false;
    setOpacity(1)
  }, []);

  useEffect(() => {
    if (!src.src) return setFlex("0 0 0%");
    else setFlex("0 0 35%");
  }, [src]);

  return (
    <motion.aside
        initial={{ opacity: 0, flex: "0 0 33%" }}
        animate={{ opacity, flex }}
        className={styles.asideIllu}
        transition={{ type: "spring", bounce: 0.3, duration: 1.2 }}
    >
        <Illustration3DScene/>
        <Cv style={!src.src ? {opacity:0, transform: 'translateX(300px)'} : { transform: 'translateX(0px)'}} isMobile={false}/>
    </motion.aside>
  );
};

export default AsideIllustration;
